var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentorOnboardOrangeSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 240,
    viewBox: "0 0 243 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.9 42.3L100.6 0L97.9 46L118.9 42.3ZM92.5 48L60.9 14.5L74.1001 58.6L92.5 48ZM69.6001 62.3L28.4 41.6L55.9 78.6L69.6001 62.3ZM53.1001 83.7L7.30005 78.4L45.8 103.7L53.1001 83.7ZM44.8 130.6V109.3L0 119.9L44.8 130.6ZM53.1001 156.3L45.8 136.3L7.30005 161.6L53.1001 156.3ZM56 161.4L28.5 198.4L69.7001 177.7L56 161.4ZM74.1001 181.4L60.9 225.5L92.5 192L74.1001 181.4ZM97.9 194L100.6 240L118.9 197.7L97.9 194ZM121.8 184.6V55.4C86.1001 55.4 57.2001 84.3 57.2001 120C57.2001 155.7 86.1001 184.6 121.8 184.6Z",
    fill: "#FCF5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.901 197.7L142.201 240L144.901 194L123.901 197.7ZM150.301 192L181.901 225.5L168.701 181.4L150.301 192ZM173.201 177.7L214.401 198.4L186.901 161.4L173.201 177.7ZM189.701 156.3L235.501 161.6L197.001 136.3L189.701 156.3ZM198.001 109.4V130.7L242.801 120.1L198.001 109.4ZM189.701 83.7L197.001 103.7L235.501 78.4L189.701 83.7ZM186.801 78.6L214.301 41.6L173.101 62.3L186.801 78.6ZM168.701 58.6L181.901 14.5L150.301 48L168.701 58.6ZM144.901 46L142.201 0L123.901 42.3L144.901 46ZM121.001 55.4L121.001 184.6C156.701 184.6 185.601 155.7 185.601 120C185.601 84.3 156.701 55.4 121.001 55.4Z",
    fill: "#FCF5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorOnboardOrangeSun);
export default __webpack_public_path__ + "static/media/MentorOnboardOrangeSun.ecbc2d7d975c8ab31836925541433562.svg";
export { ForwardRef as ReactComponent };